module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "o-settings"
  }, [_c('app-navigation', {
    attrs: {
      "currentSpace": _vm.$t('web.settings.nav_space'),
      "hideAuxNavOnDesktop": true
    }
  }), _vm._v(" "), _c('main', {
    staticClass: "o-settings__main"
  }, [_c('section', {
    staticClass: "c-page-header"
  }, [_c('div', {
    staticClass: "c-page-header__left"
  }, [_c('h1', {
    staticClass: "c-page-header__left__title"
  }, [_vm._v(_vm._s(_vm.full_name))])]), _vm._v(" "), _c('div', {
    staticClass: "c-page-header__right"
  }, [_c('a', {
    staticClass: "c-button t-button-primary qa-logout",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('web.settings.logout')) + "\n        ")])])]), _vm._v(" "), _c('section', {
    staticClass: "c-card c-card--setting"
  }, [_c('div', {
    staticClass: "c-card__header"
  }, [_c('h2', {
    staticClass: "c-card__title t-headline"
  }, [_vm._v(_vm._s(_vm.$t('web.settings.card_account_info_header')))])]), _vm._v(" "), _c('section', {
    staticClass: "c-card--setting__section"
  }, [_c('h3', {
    staticClass: "u-label"
  }, [_vm._v(_vm._s(_vm.$t('web.settings.primary_email_label')))]), _vm._v(" "), (_vm.layout.section1.template == 'detail') ? _c('div', {
    staticClass: "c-card--setting__view-fields"
  }, [_c('p', {
    staticClass: "c-card--setting__content u-word-wrap"
  }, [_vm._v(_vm._s(_vm.participant.primary_email))]), _vm._v(" "), _c('p', {
    staticClass: "c-card--setting__fieldset__note"
  }, [_vm._v(_vm._s(_vm.$t('web.settings.primary_email_hint')))]), _vm._v(" "), _c('div', {
    staticClass: "c-card--setting__buttons c-card--setting__buttons--default-mode"
  }, [_c('button', {
    staticClass: "c-button t-button-plain qa-edit-username",
    on: {
      "click": function($event) {
        return _vm.edit('section1')
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.edit_button')) + "\n            ")])])]) : _vm._e(), _vm._v(" "), (_vm.layout.section1.template == 'edit') ? _c('div', {
    staticClass: "c-card--setting__edit-fields"
  }, [_c('label', {
    staticClass: "u-hidden-label",
    attrs: {
      "for": "username"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('web.settings.primary_email_label')) + _vm._s(_vm.metadata.primary_email.required ? '*' : '') + "\n          ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.primary_email),
      expression: "participant.primary_email"
    }],
    staticClass: "qa-settings-username-input",
    attrs: {
      "type": "email",
      "name": "username",
      "tabindex": "1"
    },
    domProps: {
      "value": (_vm.participant.primary_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.participant, "primary_email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "c-card--setting__fieldset__note"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('web.settings.primary_email_hint')) + "\n          ")]), _vm._v(" "), _vm._l((_vm.errors.primary_email), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger qa-validation qa-validation"
    }, [_vm._v("\n              " + _vm._s(error) + "\n            ")])])
  }), _vm._v(" "), _c('div', {
    staticClass: "c-card--setting__buttons c-card--setting__buttons--edit-mode"
  }, [_c('button', {
    staticClass: "c-button t-button-plain qa-cancel-username",
    attrs: {
      "tabindex": "3"
    },
    on: {
      "click": function($event) {
        return _vm.reset()
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.cancel_button')) + "\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "c-button t-button-primary qa-save",
    attrs: {
      "tabindex": "2"
    },
    on: {
      "click": function($event) {
        return _vm.save('section1')
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.save_button')) + "\n            ")])])], 2) : _vm._e()]), _vm._v(" "), _c('section', {
    staticClass: "c-card--setting__section"
  }, [_c('h3', {
    staticClass: "u-label"
  }, [_vm._v(_vm._s(_vm.$t('web.settings.password_label')))]), _vm._v(" "), (_vm.layout.password_section.template == 'detail') ? _c('div', {
    staticClass: "c-card--setting__view-fields"
  }, [_c('p', {
    staticClass: "c-card--setting__content"
  }, [_vm._v("************")]), _vm._v(" "), _c('div', {
    staticClass: "c-card--setting__buttons c-card--setting__buttons--default-mode"
  }, [_c('button', {
    staticClass: "c-button t-button-plain qa-edit-password",
    on: {
      "click": function($event) {
        return _vm.edit('password_section')
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.edit_button')) + "\n            ")])])]) : _vm._e(), _vm._v(" "), (_vm.layout.password_section.template == 'edit') ? _c('div', {
    staticClass: "c-card--setting__edit-fields"
  }, [_c('ul', {
    staticClass: "u-tiny-list"
  }, [_c('li', [_vm._v(_vm._s(_vm.$t('web.settings.new_password_minimum_12_characters_note')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('web.settings.new_password_minimum_1_number_note')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('web.reset_password.new_password_minimum_1_symbol')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('web.settings.new_password_minimum_1_uppercase_note')))])]), _vm._v(" "), _c('fieldset', {
    staticClass: "c-card--setting__fieldset"
  }, [_c('label', {
    staticClass: "u-sub-label",
    attrs: {
      "for": "old_password"
    }
  }, [_vm._v(_vm._s(_vm.$t('web.settings.old_password_label')) + "*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.old_password),
      expression: "participant.old_password"
    }],
    staticClass: "qa-settings-old-password-input",
    attrs: {
      "type": "password",
      "name": "old_password",
      "tabindex": "1"
    },
    domProps: {
      "value": (_vm.participant.old_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.participant, "old_password", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.old_password), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger qa-validation"
    }, [_vm._v("\n                " + _vm._s(error) + "\n              ")])])
  })], 2), _vm._v(" "), _c('fieldset', {
    staticClass: "c-card--setting__fieldset"
  }, [_c('label', {
    staticClass: "u-sub-label",
    attrs: {
      "for": "new_password"
    }
  }, [_vm._v(_vm._s(_vm.$t('web.settings.new_password_label')) + "*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.new_password),
      expression: "participant.new_password"
    }],
    staticClass: "qa-settings-new-password-input",
    attrs: {
      "type": "password",
      "name": "new_password",
      "tabindex": "2"
    },
    domProps: {
      "value": (_vm.participant.new_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.participant, "new_password", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.new_password), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger qa-validation"
    }, [_vm._v("\n                " + _vm._s(error) + "\n              ")])])
  })], 2), _vm._v(" "), _c('fieldset', {
    staticClass: "c-card--setting__fieldset"
  }, [_c('label', {
    staticClass: "u-sub-label",
    attrs: {
      "for": "confirm_new_password"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.confirm_new_password_label')) + "*\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.confirm_new_password),
      expression: "participant.confirm_new_password"
    }],
    staticClass: "qa-settings-confirm-password-input",
    attrs: {
      "type": "password",
      "name": "confirm_new_password",
      "tabindex": "3"
    },
    domProps: {
      "value": (_vm.participant.confirm_new_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.participant, "confirm_new_password", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.confirm_new_password), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger qa-validation"
    }, [_vm._v("\n                " + _vm._s(error) + "\n              ")])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "c-card--setting__buttons c-card--setting__buttons--edit-mode"
  }, [_c('button', {
    staticClass: "c-button t-button-plain qa-cancel-password",
    attrs: {
      "tabindex": "5"
    },
    on: {
      "click": function($event) {
        return _vm.reset()
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.cancel_button')) + "\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "c-button t-button-primary qa-save",
    attrs: {
      "tabindex": "4"
    },
    on: {
      "click": function($event) {
        return _vm.save('password_section')
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.save_button')) + "\n            ")])])]) : _vm._e()]), _vm._v(" "), _c('section', {
    staticClass: "c-card--setting__section"
  }, [_c('h3', {
    staticClass: "u-label"
  }, [_vm._v(_vm._s(_vm.$t('web.settings.name_label')))]), _vm._v(" "), (_vm.layout.section3.template == 'detail') ? _c('div', {
    staticClass: "c-card--setting__view-fields"
  }, [_c('label', {
    staticClass: "u-sub-label u-hidden-label"
  }, [_vm._v(_vm._s(_vm.$t('web.settings.name_label')))]), _vm._v(" "), _c('p', {
    staticClass: "u-paragraph",
    class: {
      'u-paragraph--empty-field': (_vm.full_name === _vm.$t('web.settings.name_not_entered'))
    }
  }, [_vm._v("\n            " + _vm._s(_vm.full_name) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "c-card--setting__buttons c-card--setting__buttons--default-mode"
  }, [_c('button', {
    staticClass: "c-button t-button-plain qa-edit-name",
    on: {
      "click": function($event) {
        return _vm.edit('section3')
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.edit_button')) + "\n            ")])])]) : _vm._e(), _vm._v(" "), (_vm.layout.section3.template == 'edit') ? _c('div', {
    staticClass: "c-card--setting__edit-fields"
  }, [_c('fieldset', {
    staticClass: "c-card--setting__fieldset"
  }, [_c('label', {
    staticClass: "u-sub-label",
    attrs: {
      "for": "first_name"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.first_name_label')) + _vm._s(_vm.metadata.first_name.required ? '*' : '') + "\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.first_name),
      expression: "participant.first_name"
    }],
    staticClass: "qa-settings-first-name-input",
    attrs: {
      "type": "text",
      "name": "first_name",
      "tabindex": "1"
    },
    domProps: {
      "value": (_vm.participant.first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.participant, "first_name", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.first_name), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger qa-validation"
    }, [_vm._v("\n                " + _vm._s(error) + "\n              ")])])
  })], 2), _vm._v(" "), _c('fieldset', {
    staticClass: "c-card--setting__fieldset"
  }, [_c('label', {
    staticClass: "u-sub-label",
    attrs: {
      "for": "last_name"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.last_name_label')) + _vm._s(_vm.metadata.last_name.required ? '*' : '') + "\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.last_name),
      expression: "participant.last_name"
    }],
    staticClass: "qa-settings-last-name-input",
    attrs: {
      "type": "text",
      "name": "last_name",
      "tabindex": "2"
    },
    domProps: {
      "value": (_vm.participant.last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.participant, "last_name", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.last_name), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger qa-validation"
    }, [_vm._v("\n                " + _vm._s(error) + "\n              ")])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "c-card--setting__buttons c-card--setting__buttons--edit-mode"
  }, [_c('button', {
    staticClass: "c-button t-button-plain",
    attrs: {
      "tabindex": "4"
    },
    on: {
      "click": function($event) {
        return _vm.reset()
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.cancel_button')) + "\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "c-button t-button-primary qa-save",
    attrs: {
      "tabindex": "3"
    },
    on: {
      "click": function($event) {
        return _vm.save('section3')
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.save_button')) + "\n            ")])])]) : _vm._e()]), _vm._v(" "), _c('section', {
    staticClass: "c-card--setting__section"
  }, [_c('h3', {
    staticClass: "u-label"
  }, [_vm._v(_vm._s(_vm.$t('web.settings.preferred_name_label')))]), _vm._v(" "), (_vm.layout.section4.template == 'detail') ? _c('div', {
    staticClass: "c-card--setting__view-fields"
  }, [_c('p', {
    staticClass: "u-paragraph",
    class: {
      'u-paragraph--empty-field': (_vm.preferred_full_name === _vm.$t('web.settings.preferred_name_not_entered'))
    }
  }, [_vm._v("\n            " + _vm._s(_vm.preferred_full_name) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "c-card--setting__buttons c-card--setting__buttons--default-mode"
  }, [_c('button', {
    staticClass: "c-button t-button-plain qa-edit-preferredname",
    on: {
      "click": function($event) {
        return _vm.edit('section4')
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.edit_button')) + "\n            ")])])]) : _vm._e(), _vm._v(" "), (_vm.layout.section4.template == 'edit') ? _c('div', {
    staticClass: "c-card--setting__edit-fields"
  }, [_c('fieldset', {
    staticClass: "c-card--setting__fieldset"
  }, [_c('label', {
    staticClass: "u-sub-label",
    attrs: {
      "for": "preferred_first_name"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.preferred_first_name_label')) + _vm._s(_vm.metadata.preferred_first_name.required ? '*' : '') + "\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.preferred_first_name),
      expression: "participant.preferred_first_name"
    }],
    staticClass: "qa-settings-preferred-first-name-input",
    attrs: {
      "type": "text",
      "name": "preferred_first_name",
      "tabindex": "1"
    },
    domProps: {
      "value": (_vm.participant.preferred_first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.participant, "preferred_first_name", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.preferred_first_name), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger qa-validation"
    }, [_vm._v("\n                " + _vm._s(error) + "\n              ")])])
  })], 2), _vm._v(" "), _c('fieldset', {
    staticClass: "c-card--setting__fieldset"
  }, [_c('label', {
    staticClass: "u-sub-label",
    attrs: {
      "for": "preferred_last_name"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.preferred_last_name_label')) + _vm._s(_vm.metadata.preferred_last_name.required ? '*' : '') + "\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.preferred_last_name),
      expression: "participant.preferred_last_name"
    }],
    staticClass: "qa-settings-preferred-last-name-input",
    attrs: {
      "type": "text",
      "name": "preferred_last_name",
      "tabindex": "2"
    },
    domProps: {
      "value": (_vm.participant.preferred_last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.participant, "preferred_last_name", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.preferred_last_name), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger qa-validation"
    }, [_vm._v("\n                " + _vm._s(error) + "\n              ")])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "c-card--setting__buttons c-card--setting__buttons--edit-mode"
  }, [_c('button', {
    staticClass: "c-button t-button-plain",
    attrs: {
      "tabindex": "4"
    },
    on: {
      "click": function($event) {
        return _vm.reset()
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.cancel_button')) + "\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "c-button t-button-primary qa-save",
    attrs: {
      "tabindex": "3"
    },
    on: {
      "click": function($event) {
        return _vm.save('section4')
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.save_button')) + "\n            ")])])]) : _vm._e()])]), _vm._v(" "), (_vm.customProfile.fields.length > 0) ? _c('section', {
    staticClass: "c-card c-card--setting"
  }, [_c('div', {
    staticClass: "c-card__header"
  }, [_c('h2', {
    staticClass: "c-card__title t-headline"
  }, [_vm._v(_vm._s(_vm.customProfile.name))])]), _vm._v(" "), _vm._l((_vm.customProfile.fields), function(field) {
    return _c('section', {
      staticClass: "c-card--setting__section"
    }, [(_vm.layout['custom_section_' + field.name]) ? _c('h3', {
      staticClass: "c-card--setting__view-label u-label"
    }, [_vm._v("\n          " + _vm._s(field.label) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.layout['custom_section_' + field.name] &&
      _vm.layout['custom_section_' + field.name].template == 'detail') ? _c('div', {
      staticClass: "c-card--setting__view-fields",
      attrs: {
        "name": field.name
      }
    }, [_c(_vm.getFieldComponentType(field), {
      tag: "component",
      attrs: {
        "labelClass": "u-hidden-label",
        "field": field,
        "errors": _vm.errors,
        "name": field.name,
        "template": _vm.layout['custom_section_' + field.name].template
      },
      model: {
        value: (_vm.participant[field.name]),
        callback: function($$v) {
          _vm.$set(_vm.participant, field.name, $$v)
        },
        expression: "participant[field.name]"
      }
    }), _vm._v(" "), (!field.readonly) ? _c('div', {
      staticClass: "c-card--setting__buttons c-card--setting__buttons--default-mode"
    }, [_c('button', {
      staticClass: "c-button t-button-plain",
      class: 'qa-' + field.name + '__edit',
      on: {
        "click": function($event) {
          return _vm.edit('custom_section_' + field.name)
        }
      }
    }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.edit_button')) + "\n            ")])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.layout['custom_section_' + field.name] &&
      _vm.layout['custom_section_' + field.name].template == 'edit' &&
      !field.readonly) ? _c('div', {
      staticClass: "c-card--setting__edit-fields"
    }, [_c('fieldset', {
      staticClass: "o-fieldset c-card--submit-claim__fieldset"
    }, [_c(_vm.getFieldComponentType(field), {
      tag: "component",
      attrs: {
        "labelClass": "u-hidden-label",
        "field": field,
        "errors": _vm.errors,
        "name": field.name,
        "template": _vm.layout['custom_section_' + field.name].template
      },
      model: {
        value: (_vm.participant[field.name]),
        callback: function($$v) {
          _vm.$set(_vm.participant, field.name, $$v)
        },
        expression: "participant[field.name]"
      }
    }), _vm._v(" "), _vm._l((_vm.errors[field.name]), function(error) {
      return _c('div', [_c('div', {
        staticClass: "c-validation t-alert-danger qa-validation"
      }, [_vm._v(_vm._s(error))])])
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "c-card--setting__buttons c-card--setting__buttons--edit-mode"
    }, [_c('button', {
      staticClass: "c-button t-button-plain",
      class: 'qa-cancel',
      attrs: {
        "tabindex": "3"
      },
      on: {
        "click": function($event) {
          return _vm.reset()
        }
      }
    }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.cancel_button')) + "\n            ")]), _vm._v(" "), _c('button', {
      staticClass: "c-button t-button-primary qa-save",
      class: 'qa-save',
      attrs: {
        "tabindex": "2"
      },
      on: {
        "click": function($event) {
          return _vm.save('custom_section_' + field.name)
        }
      }
    }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.save_button')) + "\n            ")])])]) : _vm._e()])
  })], 2) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "c-card c-card--setting"
  }, [_c('div', {
    staticClass: "c-card__header"
  }, [_c('h2', {
    staticClass: "c-card__title t-headline"
  }, [_vm._v(_vm._s(_vm.$t('web.settings.card_contact_info_header')))])]), _vm._v(" "), _c('section', {
    staticClass: "c-card--setting__section"
  }, [_c('h3', {
    staticClass: "u-label"
  }, [_vm._v(_vm._s(_vm.$t('web.settings.email_addresses_label')))]), _vm._v(" "), (_vm.layout.section6.template == 'detail') ? _c('div', {
    staticClass: "c-card--setting__view-fields"
  }, [_c('div', {
    staticClass: "c-card--setting__fieldset"
  }, [_c('label', {
    staticClass: "u-sub-label"
  }, [_vm._v(_vm._s(_vm.$t('web.settings.secondary_email_label')))]), _vm._v(" "), _c('p', {
    staticClass: "u-paragraph u-word-wrap",
    class: {
      'u-paragraph--empty-field': (!_vm.participant.secondary_email)
    }
  }, [_vm._v("\n              " + _vm._s(_vm.participant.secondary_email ? _vm.participant.secondary_email : _vm.$t('web.settings.secondary_email_not_entered')) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "c-card--setting__fieldset"
  }, [_c('label', {
    staticClass: "u-sub-label"
  }, [_vm._v(_vm._s(_vm.$t('web.settings.other_email_label')))]), _vm._v(" "), _c('p', {
    staticClass: "u-paragraph u-word-wrap",
    class: {
      'u-paragraph--empty-field': (!_vm.participant.other_email)
    }
  }, [_vm._v("\n              " + _vm._s(_vm.participant.other_email ? _vm.participant.other_email : _vm.$t('web.settings.other_email_not_entered')) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "c-card--setting__buttons c-card--setting__buttons--default-mode"
  }, [_c('button', {
    staticClass: "c-button t-button-plain qa-edit-email-addresses",
    on: {
      "click": function($event) {
        return _vm.edit('section6')
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.edit_button')) + "\n            ")])])]) : _vm._e(), _vm._v(" "), (_vm.layout.section6.template == 'edit') ? _c('div', {
    staticClass: "c-card--setting__edit-fields"
  }, [_c('fieldset', {
    staticClass: "c-card--setting__section-fieldset"
  }, [_c('label', {
    staticClass: "u-sub-label",
    attrs: {
      "for": "secondary_email"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.secondary_email_label')) + _vm._s(_vm.metadata.secondary_email.required ? '*' : '') + "\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.secondary_email),
      expression: "participant.secondary_email"
    }],
    staticClass: "qa-settings-secondary-email-input",
    attrs: {
      "type": "email",
      "name": "secondary_email",
      "tabindex": "1"
    },
    domProps: {
      "value": (_vm.participant.secondary_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.participant, "secondary_email", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.secondary_email), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger qa-validation"
    }, [_vm._v("\n                " + _vm._s(error) + "\n              ")])])
  })], 2), _vm._v(" "), _c('fieldset', {
    staticClass: "c-card--setting__section-fieldset"
  }, [_c('label', {
    staticClass: "u-sub-label",
    attrs: {
      "for": "other_email"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.other_email_label')) + _vm._s(_vm.metadata.other_email.required ? '*' : '') + "\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.other_email),
      expression: "participant.other_email"
    }],
    staticClass: "qa-settings-other-email-input",
    attrs: {
      "type": "email",
      "name": "other_email",
      "tabindex": "2"
    },
    domProps: {
      "value": (_vm.participant.other_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.participant, "other_email", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.other_email), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger qa-validation"
    }, [_vm._v(_vm._s(error))])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "c-card--setting__buttons c-card--setting__buttons--edit-mode"
  }, [_c('button', {
    staticClass: "c-button t-button-plain",
    attrs: {
      "tabindex": "4"
    },
    on: {
      "click": function($event) {
        return _vm.reset()
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.cancel_button')) + "\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "c-button t-button-primary qa-save",
    attrs: {
      "tabindex": "3"
    },
    on: {
      "click": function($event) {
        return _vm.save('section6')
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.save_button')) + "\n            ")])])]) : _vm._e()]), _vm._v(" "), _c('section', {
    staticClass: "c-card--setting__section c-card--setting__section--phones"
  }, [_c('h3', {
    staticClass: "u-label"
  }, [_vm._v(_vm._s(_vm.$t('web.settings.phone_numbers_label')))]), _vm._v(" "), (_vm.layout.section7.template == 'detail') ? _c('div', {
    staticClass: "c-card--setting__view-fields"
  }, [_c('div', {
    staticClass: "c-card--setting__fieldset c-card--setting__section--phones__fieldset"
  }, [_c('label', {
    staticClass: "u-sub-label"
  }, [_vm._v(_vm._s(_vm.$t('web.settings.mobile_phone_label')))]), _vm._v(" "), _c('p', {
    staticClass: "u-paragraph",
    class: {
      'u-paragraph--empty-field': (!_vm.participant.mobile_phone)
    }
  }, [_vm._v("\n              " + _vm._s(_vm.participant.mobile_phone ? _vm.participant.mobile_phone : _vm.$t('web.settings.mobile_phone_not_entered')) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "c-card--setting__fieldset c-card--setting__section--phones__fieldset"
  }, [_c('label', {
    staticClass: "u-sub-label"
  }, [_vm._v(_vm._s(_vm.$t('web.settings.business_phone_label')))]), _vm._v(" "), _c('p', {
    staticClass: "u-paragraph",
    class: {
      'u-paragraph--empty-field': (!_vm.participant.business_phone)
    }
  }, [_vm._v("\n              " + _vm._s(_vm.participant.business_phone ? _vm.participant.business_phone : _vm.$t('web.settings.business_phone_not_entered')) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "c-card--setting__fieldset c-card--setting__section--phones__fieldset"
  }, [_c('label', {
    staticClass: "u-sub-label"
  }, [_vm._v(_vm._s(_vm.$t('web.settings.home_phone_label')))]), _vm._v(" "), _c('p', {
    staticClass: "u-paragraph",
    class: {
      'u-paragraph--empty-field': (!_vm.participant.home_phone)
    }
  }, [_vm._v("\n              " + _vm._s(_vm.participant.home_phone ? _vm.participant.home_phone : _vm.$t('web.settings.home_phone_not_entered')) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "c-card--setting__buttons c-card--setting__buttons--default-mode"
  }, [_c('button', {
    staticClass: "c-button t-button-plain qa-edit-phone-numbers",
    on: {
      "click": function($event) {
        return _vm.edit('section7')
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.edit_button')) + "\n            ")])])]) : _vm._e(), _vm._v(" "), (_vm.layout.section7.template == 'edit') ? _c('div', {
    staticClass: "c-card--setting__edit-fields"
  }, [_c('fieldset', {
    staticClass: "c-card--setting__fieldset c-card--setting__section--phones__fieldset"
  }, [_c('label', {
    staticClass: "u-sub-label",
    attrs: {
      "for": "mobile_phone"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.mobile_phone_label')) + _vm._s(_vm.metadata.mobile_phone.required ? '*' : '') + "\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.mobile_phone),
      expression: "participant.mobile_phone"
    }],
    staticClass: "qa-settings-mobile-phone-input",
    attrs: {
      "type": "text",
      "name": "mobile_phone",
      "tabindex": "1"
    },
    domProps: {
      "value": (_vm.participant.mobile_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.participant, "mobile_phone", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.mobile_phone), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger qa-validation"
    }, [_vm._v(_vm._s(error))])])
  })], 2), _vm._v(" "), _c('fieldset', {
    staticClass: "c-card--setting__fieldset c-card--setting__section--phones__fieldset"
  }, [_c('label', {
    staticClass: "u-sub-label",
    attrs: {
      "for": "business_phone"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.business_phone_label')) + _vm._s(_vm.metadata.business_phone.required ? '*' : '') + "\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.business_phone),
      expression: "participant.business_phone"
    }],
    staticClass: "qa-settings-business-phone-input",
    attrs: {
      "type": "text",
      "name": "business_phone",
      "tabindex": "2"
    },
    domProps: {
      "value": (_vm.participant.business_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.participant, "business_phone", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.business_phone), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger qa-validation"
    }, [_vm._v("\n                " + _vm._s(error) + "\n              ")])])
  })], 2), _vm._v(" "), _c('fieldset', {
    staticClass: "c-card--setting__fieldset c-card--setting__section--phones__fieldset"
  }, [_c('label', {
    staticClass: "u-sub-label",
    attrs: {
      "for": "home_phone"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.home_phone_label')) + _vm._s(_vm.metadata.home_phone.required ? '*' : '') + "\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.home_phone),
      expression: "participant.home_phone"
    }],
    staticClass: "qa-settings-home-phone-input",
    attrs: {
      "type": "text",
      "name": "home_phone",
      "tabindex": "3"
    },
    domProps: {
      "value": (_vm.participant.home_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.participant, "home_phone", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.home_phone), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger qa-validation"
    }, [_vm._v("\n                " + _vm._s(error) + "\n              ")])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "c-card--setting__buttons c-card--setting__buttons--edit-mode"
  }, [_c('button', {
    staticClass: "c-button t-button-plain",
    attrs: {
      "tabindex": "5"
    },
    on: {
      "click": function($event) {
        return _vm.reset()
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.cancel_button')) + "\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "c-button t-button-primary qa-save",
    attrs: {
      "tabindex": "4"
    },
    on: {
      "click": function($event) {
        return _vm.save('section7')
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.save_button')) + "\n            ")])])]) : _vm._e()]), _vm._v(" "), _c('section', {
    staticClass: "c-card--setting__section"
  }, [_c('h3', {
    staticClass: "u-label"
  }, [_vm._v(_vm._s(_vm.$t('web.settings.home_address_label')))]), _vm._v(" "), (_vm.layout.section8.template == 'detail') ? _c('div', {
    staticClass: "c-card--setting__view-fields"
  }, [_c('div', {
    staticClass: "c-card--setting__fieldset"
  }, [(_vm.home_address_empty) ? _c('address', {
    staticClass: "u-paragraph u-paragraph--empty-field"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.home_address_not_entered')) + "\n            ")]) : _vm._e(), _vm._v(" "), (!_vm.home_address_empty) ? _c('address', {
    staticClass: "u-paragraph"
  }, [_vm._v("\n              " + _vm._s(_vm.participant.home_address1) + " "), (_vm.participant.home_address1) ? _c('br') : _vm._e(), _vm._v("\n              " + _vm._s(_vm.participant.home_address2) + " "), (_vm.participant.home_address2) ? _c('br') : _vm._e(), _vm._v("\n              " + _vm._s(_vm.participant.home_city ? (_vm.participant.home_city + ', ') : '') + "\n              " + _vm._s(_vm.participant.home_state ? (_vm.participant.home_state + ' ') : '') + "\n              " + _vm._s(_vm.participant.home_zip_code) + " "), (_vm.participant.home_country) ? _c('br') : _vm._e(), _vm._v("\n              " + _vm._s(_vm.getDropdownLabel(_vm.participant.home_country, _vm.metadata.home_country.options)) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "c-card--setting__buttons c-card--setting__buttons--default-mode"
  }, [_c('button', {
    staticClass: "c-button t-button-plain qa-edit-legal-address",
    on: {
      "click": function($event) {
        return _vm.edit('section8')
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.edit_button')) + "\n            ")])])]) : _vm._e(), _vm._v(" "), (_vm.layout.section8.template == 'edit') ? _c('div', {
    staticClass: "c-card--setting__edit-fields"
  }, [_c('p', {
    staticClass: "c-card--setting__fieldset__note"
  }, [_vm._v(_vm._s(_vm.$t('web.settings.home_address_hint')))]), _vm._v(" "), _c('fieldset', {
    staticClass: "c-card--setting__fieldset c-card--setting__fieldset--address"
  }, [_c('label', {
    staticClass: "u-sub-label u-word-wrap",
    attrs: {
      "for": "home_address1"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.home_address1_label')) + _vm._s(_vm.metadata.home_address1.required ? '*' : '') + "\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.home_address1),
      expression: "participant.home_address1"
    }],
    staticClass: "qa-settings-street-line-1-input",
    attrs: {
      "type": "text",
      "name": "home_address2",
      "tabindex": "1"
    },
    domProps: {
      "value": (_vm.participant.home_address1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.participant, "home_address1", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.home_address1), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger qa-validation"
    }, [_vm._v("\n                " + _vm._s(error) + "\n              ")])])
  }), _vm._v(" "), _c('label', {
    staticClass: "u-sub-label",
    attrs: {
      "for": "home_address2"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.home_address2_label')) + _vm._s(_vm.metadata.home_address2.required ? '*' : '') + "\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.home_address2),
      expression: "participant.home_address2"
    }],
    staticClass: "qa-settings-street-line-2-input",
    attrs: {
      "type": "text",
      "name": "home_address2",
      "placeholder": _vm.$t('web.settings.home_address2_placeholder'),
      "tabindex": "2"
    },
    domProps: {
      "value": (_vm.participant.home_address2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.participant, "home_address2", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.home_address2), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger qa-validation"
    }, [_vm._v("\n                " + _vm._s(error) + "\n              ")])])
  }), _vm._v(" "), _c('div', {
    staticClass: "c-card--setting__fieldset--address__city-state-zip-country"
  }, [_c('label', {
    staticClass: "u-sub-label",
    attrs: {
      "for": "home_city"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('web.settings.home_city_label')) + _vm._s(_vm.metadata.home_city.required ? '*' : '') + "\n              ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.home_city),
      expression: "participant.home_city"
    }],
    staticClass: "qa-settings-city-input",
    attrs: {
      "type": "text",
      "name": "home_city",
      "tabindex": "3"
    },
    domProps: {
      "value": (_vm.participant.home_city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.participant, "home_city", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.home_city), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger qa-validation"
    }, [_vm._v("\n                  " + _vm._s(error) + "\n                ")])])
  }), _vm._v(" "), _c('label', {
    staticClass: "u-sub-label",
    attrs: {
      "for": "home_state"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('web.settings.home_state_label')) + _vm._s(_vm.metadata.home_state.required ? '*' : '') + "\n              ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.home_state),
      expression: "participant.home_state"
    }],
    staticClass: "qa-settings-state-input",
    attrs: {
      "name": "home_state",
      "tabindex": "4"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.participant, "home_state", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.metadata.home_state.options), function(item) {
    return _c('option', {
      domProps: {
        "value": item.value
      }
    }, [_vm._v("\n                  " + _vm._s(item.label) + "\n                ")])
  })], 2), _vm._v(" "), _vm._l((_vm.errors.home_state), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger qa-validation"
    }, [_vm._v("\n                  " + _vm._s(error) + "\n                ")])])
  }), _vm._v(" "), _c('label', {
    staticClass: "u-sub-label",
    attrs: {
      "for": "legal-zip"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('web.settings.home_zip_code_label')) + _vm._s(_vm.metadata.home_zip_code.required ? '*' : '') + "\n              ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.home_zip_code),
      expression: "participant.home_zip_code"
    }],
    staticClass: "qa-settings-zip-input",
    attrs: {
      "type": "text",
      "maxlength": "6",
      "name": "home_zip_code",
      "tabindex": "5"
    },
    domProps: {
      "value": (_vm.participant.home_zip_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.participant, "home_zip_code", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.home_zip_code), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger qa-validation"
    }, [_vm._v("\n                  " + _vm._s(error) + "\n                ")])])
  }), _vm._v(" "), _c('label', {
    staticClass: "u-sub-label",
    attrs: {
      "for": "home_country"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('web.settings.home_country_label')) + _vm._s(_vm.metadata.home_country.required ? '*' : '') + "\n              ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.home_country),
      expression: "participant.home_country"
    }],
    staticClass: "qa-settings-country-input",
    attrs: {
      "name": "home_country",
      "tabindex": "6"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.participant, "home_country", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.metadata.home_country.options), function(item) {
    return _c('option', {
      domProps: {
        "value": item.value
      }
    }, [_vm._v("\n                  " + _vm._s(item.label) + "\n                ")])
  })], 2), _vm._v(" "), _vm._l((_vm.errors.home_country), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger qa-validation"
    }, [_vm._v("\n                  " + _vm._s(error) + "\n                ")])])
  })], 2)], 2), _vm._v(" "), _c('div', {
    staticClass: "c-card--setting__buttons c-card--setting__buttons--edit-mode"
  }, [_c('button', {
    staticClass: "c-button t-button-plain",
    attrs: {
      "tabindex": "8"
    },
    on: {
      "click": function($event) {
        return _vm.reset()
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.cancel_button')) + "\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "c-button t-button-primary qa-save",
    attrs: {
      "tabindex": "7"
    },
    on: {
      "click": function($event) {
        return _vm.save('section8')
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.save_button')) + "\n            ")])])]) : _vm._e()]), _vm._v(" "), _c('section', {
    staticClass: "c-card--setting__section"
  }, [_c('h3', {
    staticClass: "u-label"
  }, [_vm._v(_vm._s(_vm.$t('web.settings.shipping_information_label')))]), _vm._v(" "), (_vm.layout.section9.template == 'detail') ? _c('div', {
    staticClass: "c-card--setting__view-fields"
  }, [_c('div', {
    staticClass: "c-card--setting__fieldset"
  }, [_c('label', {
    staticClass: "u-sub-label"
  }, [_vm._v(_vm._s(_vm.$t('web.settings.shipping_address_label')))]), _vm._v(" "), (_vm.shipping_address_empty) ? _c('address', {
    staticClass: "u-paragraph u-paragraph--empty-field"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.shipping_address_not_entered')) + "\n            ")]) : _vm._e(), _vm._v(" "), (!_vm.shipping_address_empty) ? _c('address', {
    staticClass: "u-paragraph"
  }, [_vm._v("\n              " + _vm._s(_vm.participant.shipping_first_name) + " "), (_vm.participant.shipping_first_name) ? _c('br') : _vm._e(), _vm._v("\n              " + _vm._s(_vm.participant.shipping_last_name) + " "), (_vm.participant.shipping_last_name) ? _c('br') : _vm._e(), _vm._v("\n              " + _vm._s(_vm.participant.shipping_address1) + " "), (_vm.participant.shipping_address1) ? _c('br') : _vm._e(), _vm._v("\n              " + _vm._s(_vm.participant.shipping_address2) + " "), (_vm.participant.shipping_address2) ? _c('br') : _vm._e(), _vm._v("\n              " + _vm._s(_vm.participant.shipping_city ? (_vm.participant.shipping_city + ', ') : '') + "\n              " + _vm._s(_vm.participant.shipping_state ? (_vm.participant.shipping_state + ' ') : '') + "\n              " + _vm._s(_vm.participant.shipping_zip_code) + " "), (_vm.participant.shipping_country) ? _c('br') : _vm._e(), _vm._v("\n              " + _vm._s(_vm.getDropdownLabel(_vm.participant.shipping_country, _vm.metadata.shipping_country.options)) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "u-sub-label"
  }, [_vm._v(_vm._s(_vm.$t('web.settings.shipping_email_label')))]), _vm._v(" "), (_vm.participant.shipping_email) ? _c('span', {
    staticClass: "u-paragraph u-word-wrap"
  }, [_vm._v("\n              " + _vm._s(_vm.participant.shipping_email) + "\n            ")]) : _c('span', {
    staticClass: "u-paragraph u-paragraph--empty-field"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.shipping_email_not_entered')) + "\n            ")]), _vm._v(" "), _c('label', {
    staticClass: "u-sub-label"
  }, [_vm._v(_vm._s(_vm.$t('web.settings.shipping_phone_label')))]), _vm._v(" "), (_vm.participant.shipping_phone) ? _c('span', {
    staticClass: "u-paragraph"
  }, [_vm._v("\n              " + _vm._s(_vm.participant.shipping_phone) + "\n            ")]) : _c('span', {
    staticClass: "u-paragraph u-paragraph--empty-field"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.shipping_phone_not_entered')) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "c-card--setting__buttons c-card--setting__buttons--default-mode"
  }, [_c('button', {
    staticClass: "c-button t-button-plain qa-edit-shipping-info",
    on: {
      "click": function($event) {
        return _vm.edit('section9')
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.edit_button')) + "\n            ")])])]) : _vm._e(), _vm._v(" "), (_vm.layout.section9.template == 'edit') ? _c('div', {
    staticClass: "c-card--setting__edit-fields"
  }, [_c('fieldset', {
    staticClass: "c-card--setting__fieldset c-card--setting__fieldset--address"
  }, [_c('p', {
    staticClass: "c-card--setting__fieldset__note"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.shipping_address_hint')) + "\n            ")]), _vm._v(" "), _c('label', {
    staticClass: "u-sub-label",
    attrs: {
      "for": "shipping_first_name"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.shipping_first_name_label')) + _vm._s(_vm.metadata.shipping_first_name.required ? '*' : '') + "\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.shipping_first_name),
      expression: "participant.shipping_first_name"
    }],
    staticClass: "qa-settings-shipping-name-input",
    attrs: {
      "type": "text",
      "name": "shipping_first_name",
      "tabindex": "1"
    },
    domProps: {
      "value": (_vm.participant.shipping_first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.participant, "shipping_first_name", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.shipping_first_name), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger qa-validation"
    }, [_vm._v("\n                " + _vm._s(error) + "\n              ")])])
  }), _vm._v(" "), _c('label', {
    staticClass: "u-sub-label",
    attrs: {
      "for": "shipping_last_name"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.shipping_last_name_label')) + _vm._s(_vm.metadata.shipping_last_name.required ? '*' : '') + "\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.shipping_last_name),
      expression: "participant.shipping_last_name"
    }],
    staticClass: "qa-settings-shipping-name-input",
    attrs: {
      "type": "text",
      "name": "shipping_last_name",
      "tabindex": "1"
    },
    domProps: {
      "value": (_vm.participant.shipping_last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.participant, "shipping_last_name", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.shipping_last_name), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger qa-validation"
    }, [_vm._v("\n                " + _vm._s(error) + "\n              ")])])
  }), _vm._v(" "), _c('label', {
    staticClass: "u-sub-label",
    attrs: {
      "for": "shipping_address1"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.shipping_address1_label')) + _vm._s(_vm.metadata.shipping_address1.required ? '*' : '') + "\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.shipping_address1),
      expression: "participant.shipping_address1"
    }],
    staticClass: "qa-settings-shipping-street-line-1-input",
    attrs: {
      "type": "text",
      "name": "shipping_address1",
      "tabindex": "2"
    },
    domProps: {
      "value": (_vm.participant.shipping_address1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.participant, "shipping_address1", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.shipping_address1), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger qa-validation"
    }, [_vm._v("\n                " + _vm._s(error) + "\n              ")])])
  }), _vm._v(" "), _c('label', {
    staticClass: "u-sub-label",
    attrs: {
      "for": "shipping_address2"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.shipping_address2_label')) + _vm._s(_vm.metadata.shipping_address2.required ? '*' : '') + "\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.shipping_address2),
      expression: "participant.shipping_address2"
    }],
    staticClass: "qa-settings-shipping-street-line-2-input",
    attrs: {
      "type": "text",
      "name": "shipping_address2",
      "placeholder": _vm.$t('web.settings.shipping_address2_placeholder'),
      "tabindex": "3"
    },
    domProps: {
      "value": (_vm.participant.shipping_address2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.participant, "shipping_address2", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.shipping_address2), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger qa-validation"
    }, [_vm._v("\n                " + _vm._s(error) + "\n              ")])])
  }), _vm._v(" "), _c('div', {
    staticClass: "c-card--setting__fieldset--address__city-state-zip"
  }, [_c('label', {
    staticClass: "u-sub-label",
    attrs: {
      "for": "shipping_city"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('web.settings.shipping_city_label')) + _vm._s(_vm.metadata.shipping_city.required ? '*' : '') + "\n              ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.shipping_city),
      expression: "participant.shipping_city"
    }],
    staticClass: "qa-settings-shipping-city-input",
    attrs: {
      "type": "text",
      "name": "shipping_city",
      "tabindex": "4"
    },
    domProps: {
      "value": (_vm.participant.shipping_city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.participant, "shipping_city", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.shipping_city), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger qa-validation"
    }, [_vm._v("\n                  " + _vm._s(error) + "\n                ")])])
  }), _vm._v(" "), _c('label', {
    staticClass: "u-sub-label",
    attrs: {
      "for": "shipping_state"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('web.settings.shipping_state_label')) + _vm._s(_vm.metadata.shipping_state.required ? '*' : '') + "\n              ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.shipping_state),
      expression: "participant.shipping_state"
    }],
    staticClass: "qa-settings-shipping-state-input",
    attrs: {
      "name": "shipping_state",
      "tabindex": "5"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.participant, "shipping_state", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.metadata.shipping_state.options), function(item) {
    return _c('option', {
      domProps: {
        "value": item.value
      }
    }, [_vm._v("\n                  " + _vm._s(item.label) + "\n                ")])
  })], 2), _vm._v(" "), _vm._l((_vm.errors.shipping_state), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger qa-validation"
    }, [_vm._v("\n                  " + _vm._s(error) + "\n                ")])])
  }), _vm._v(" "), _c('label', {
    staticClass: "u-sub-label",
    attrs: {
      "for": "shipping_zip_code"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('web.settings.shipping_zip_code_label')) + _vm._s(_vm.metadata.shipping_zip_code.required ? '*' : '') + "\n              ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.shipping_zip_code),
      expression: "participant.shipping_zip_code"
    }],
    staticClass: "qa-settings-shipping-zip-input",
    attrs: {
      "type": "text",
      "maxlength": "6",
      "name": "shipping_zip_code",
      "tabindex": "6"
    },
    domProps: {
      "value": (_vm.participant.shipping_zip_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.participant, "shipping_zip_code", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.shipping_zip_code), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger qa-validation"
    }, [_vm._v("\n                  " + _vm._s(error) + "\n                ")])])
  }), _vm._v(" "), _c('label', {
    staticClass: "u-sub-label",
    attrs: {
      "for": "shipping_country"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('web.settings.shipping_country_label')) + _vm._s(_vm.metadata.shipping_country.required ? '*' : '') + "\n              ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.shipping_country),
      expression: "participant.shipping_country"
    }],
    staticClass: "qa-settings-country-input",
    attrs: {
      "name": "shipping_country",
      "tabindex": "7"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.participant, "shipping_country", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.metadata.shipping_country.options), function(item) {
    return _c('option', {
      domProps: {
        "value": item.value
      }
    }, [_vm._v("\n                  " + _vm._s(item.label) + "\n                ")])
  })], 2), _vm._v(" "), _vm._l((_vm.errors.shipping_country), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger qa-validation"
    }, [_vm._v("\n                  " + _vm._s(error) + "\n                ")])])
  })], 2), _vm._v(" "), _c('label', {
    staticClass: "u-sub-label",
    attrs: {
      "for": "shipping_email"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.shipping_email_label')) + _vm._s(_vm.metadata.shipping_email.required ? '*' : '') + "\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.shipping_email),
      expression: "participant.shipping_email"
    }],
    staticClass: "qa-settings-shipping-email-input",
    attrs: {
      "type": "text",
      "name": "shipping_email",
      "tabindex": "8"
    },
    domProps: {
      "value": (_vm.participant.shipping_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.participant, "shipping_email", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.shipping_email), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger qa-validation"
    }, [_vm._v("\n                " + _vm._s(error) + "\n              ")])])
  }), _vm._v(" "), _c('label', {
    staticClass: "u-sub-label",
    attrs: {
      "for": "shipping_phone"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.shipping_phone_label')) + _vm._s(_vm.metadata.shipping_phone.required ? '*' : '') + "\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.shipping_phone),
      expression: "participant.shipping_phone"
    }],
    staticClass: "qa-settings-shipping-phone-input",
    attrs: {
      "type": "text",
      "name": "shipping_phone",
      "tabindex": "9"
    },
    domProps: {
      "value": (_vm.participant.shipping_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.participant, "shipping_phone", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.shipping_phone), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger qa-validation"
    }, [_vm._v("\n                " + _vm._s(error) + "\n              ")])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "c-card--setting__buttons c-card--setting__buttons--edit-mode"
  }, [_c('button', {
    staticClass: "c-button t-button-plain",
    attrs: {
      "tabindex": "11"
    },
    on: {
      "click": function($event) {
        return _vm.reset()
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.cancel_button')) + "\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "c-button t-button-primary qa-save",
    attrs: {
      "tabindex": "10"
    },
    on: {
      "click": function($event) {
        return _vm.save('section9')
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.settings.save_button')) + "\n            ")])])]) : _vm._e()])])]), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-11e04fda"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Settings.vue
// module id = 511
// module chunks = 1